import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getTrainerHistorySlice = createSlice({
    name: 'TrainerHistory',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchTrainerHistory.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchTrainerHistory.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchTrainerHistory.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainerHistory, setStatus } = getTrainerHistorySlice.actions;
export default getTrainerHistorySlice.reducer;

export const fetchTrainerHistory = createAsyncThunk('/TrainerHistoryget/fetch', async ({trainerid}) => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/TrainerHistory/${trainerid}`, {
        headers
    });
    const TrainerHistoryData = res.data;
    return TrainerHistoryData.data;
})
